import React from "react";
import styles from "./audioPlayer.module.css";

const AudioPlayer = ({ audioUrl }) => {
  return (
    <div className={styles.audio_player_container}>
      <audio controls src={audioUrl}>
        <a href={audioUrl}>Download audio</a>
      </audio>
    </div>
  );
};

export default AudioPlayer;
